export { default } from "./PowerWordQuizResponseItem";
